export default function Menu(props) {
   
    const s = props?.size ?? 24
    const c = props?.color ?? "#292D32"
    const stroke = props?.strokeWidth ?? 1.5
    
    return (
    <svg width={s} height={s} viewBox="0 0 23 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M22 10V15C22 20 20 22 15 22H9C4 22 2 20 2 15V9C2 4 4 2 9 2H14M22 10H18C15 10 14 9 14 6V2M22 10L14 2M7 13H13M7 17H11" stroke={c} strokeWidth={stroke} />
    </svg>
    )
}

